import React, {useEffect, useState} from 'react';
import ReactDOM from "react-dom";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {route, useRoute} from 'ziggy-js';
import {ToastProvider} from "toolbox-react-frontend-components";
import {getAuthToken} from "../helpers/AuthTokenHelper";
import LoadingPane from "../components/LoadingPane";

const AdminUnauthedApp = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (loading) {
            setupApplication();
        }
    }, [loading]);

    const setupApplication = () => {
        const token = getAuthToken();

        /*
         * Check if token is set, if not redirect to login.
         */
        if (!!token) {
            window.location.href = route('admin.dashboard');
            return;
        }

        setLoading(false);
    }

    const router = createBrowserRouter([
        {
            path: route('admin.login', undefined, false),
            element: (
                <LoginPage />
            ),
        }, {
            path: route('admin.password.request', undefined, false),
            element: (
                <ForgotPasswordPage />
            ),
        }, {
            path: route('admin.password.reset', {
                token: !!route().params && !!route().params.token ? route().params.token : '',
            }, false),
            element: (
                <ResetPasswordPage />
            ),
        }
    ]);

    if (loading) {
        return (
            <LoadingPane />
        )
    }

    return (
        <ToastProvider
            position={'top-right'}
        >
            <RouterProvider router={router} />
        </ToastProvider>
    );
}

export default AdminUnauthedApp;

const app = document.getElementById('admin-unauthed-app');
if (app) {
    ReactDOM.render(<AdminUnauthedApp />, app);
}
